import DefectNotifyPopup from "./defectNotifyPopup";

export default DefectNotifyPopup;
